import { render } from "./Speaking.vue?vue&type=template&id=5c326099&scoped=true"
import script from "./Speaking.vue?vue&type=script&lang=js"
export * from "./Speaking.vue?vue&type=script&lang=js"

import "./Speaking.vue?vue&type=style&index=0&id=5c326099&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c326099"]])

export default __exports__